import React, { Component } from 'react';
import RequestApi from '../../Miscelania/RequestApi';
import config from 'react-global-configuration';
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

// Importação do Router
import { Redirect, Link } from 'react-router-dom';
import Select from 'react-select';

const PropTypes = require('prop-types');

class ExamUnrelatedAcoes extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      class_edit: '',
      class_status: '',
      alt_status: '',
      title_status: '',
      staff_id: '',
      modal: false,
      dados: [],
    };
    //bind geral
    this.showModal = this.showModal.bind(this);
    this.downloadExam = this.downloadExam.bind(this);
    this.trocarActive = this.trocarActive.bind(this);
    this.cadastrarAlunos = this.cadastrarAlunos.bind(this);
  }

  // Handlers de form
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.verifyPermission();
  }

  trocarActive () {
    var toggle = this.state.active;
    var datasave = {
      id: this.props.dadosProva.id,
      active: 0,
    };
    var confirmacao = window.confirm('Tem certeza que deseja arquivar essa prova?');
    if(confirmacao) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/change_active', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshTable(responseJson);
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  downloadExam () {
    var self = this;
    self.props.handleAlert('', '', 'open');
    var url = config.get('api') + '/download/prova/' + this.props.dadosProva.id;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
          self.props.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  showModal(event) {
    this.setState({ modal: true });
  }

  cadastrarAlunos(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var dados_salvar = {
      staff_ids: this.state.staff_ids,
      matter_id: this.props.dadosProva.matter_id,
      setting_level_id: this.props.dadosProva.setting_level_id,
      id: this.props.dadosProva.id,
    };
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cadastrar/aluno/prova/nao/relacionada', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({ modal: false });
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <button onClick={this.trocarActive} className='btn btn-xs btn-success' alt='Trocar para arquivado' title="Trocar para arquivado"><i className="fa fa-fw fa-power-off"></i></button>
  <button alt="Inputar aluno" title="Inputar aluno" onClick={this.showModal} className='btn btn-primary btn-xs'><i className="fa fa-fw fa-user-plus"></i></button>
  <button alt="Download de prova" title="Imprimir prova" onClick={this.downloadExam} className='btn btn-info btn-xs'><i className="fa fa-fw fa-print"></i></button>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-sm" bsSize={'large'}>
    <Modal.Header className='modal-prova'>
      <div className="row">
        <div className="col-md-6">
        </div>
        <div className="col-md-6">
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </div>
      </div>
    </Modal.Header>
    <Modal.Body className='modal-prova'>
      <div className="row dados-prova-modal">
        <div className="col-md-6">
            <p><b>Código: </b>{this.props.dadosProva.id}</p>
            <p><b>Matéria: </b>{this.props.dadosProva.matter}</p>
            <p><b>Dificuldade: </b>{this.props.dadosProva.dificuldade}</p>
            <p><b>Nota mínima: </b>{this.props.dadosProva.nota_minima}</p>
            <br/>
        </div>
        <div className="col-md-6">
          <label>Alunos:</label>
          <Select
            className="form-field-name"
            name="staff_ids"
            value={this.state.staff_ids}
            searchable={true}
            multi={true}
            placeholder={'Selecione os alunos'}
            onChange={this.handleSelectChange.bind(this, 'staff_ids')}
            options={this.props.lista_alunos}
            required
          />
        </div>
      </div>
      <button onClick={this.cadastrarAlunos} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Cadastrar alunos</button>
    </Modal.Body>
    <Modal.Footer className='modal-prova'>
      <div className="row">
        <div className="col-md-6">
        </div>
        <div className="col-md-6">
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </div>
      </div>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

ExamUnrelatedAcoes.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default ExamUnrelatedAcoes;



// WEBPACK FOOTER //
// ./src/Components/Exams/Elements/ExamUnrelatedAcoes.js